import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';

interface Props {
  configRequirementsMet: boolean;
  disabled: boolean;
  hasNoChanges: boolean;
  isEvaluating: boolean;
  isLoading: boolean;
  readOnly: boolean;
  shouldRetry: boolean;
  onClick: () => void;
}

export const SaveAndEvaluateButton = ({
  configRequirementsMet,
  disabled,
  hasNoChanges,
  isEvaluating,
  isLoading,
  readOnly,
  shouldRetry,
  onClick,
}: Props) => {
  const intl = useIntl();
  return (
    <Button
      disabled={disabled}
      isLoading={isLoading}
      text={
        isLoading
          ? intl.formatMessage({
              id: 'XRayConfiguration.saveAndEvaluate.savingText',
              defaultMessage: 'Saving…',
              description: 'Text for save and evaluate button when saving.',
            })
          : shouldRetry
            ? intl.formatMessage({
                id: 'XRayConfiguration.saveAndEvaluate.retryText',
                defaultMessage: 'Retry Evaluation',
                description:
                  'Text for retry evaluation button when some model results failed to evaluate.',
              })
            : intl.formatMessage({
                id: 'XRayConfiguration.saveAndEvaluate.buttonText',
                defaultMessage: 'Save and Evaluate',
                description:
                  'Text for save and evaluate button in Custom AI configuration.',
              })
      }
      tooltip={
        readOnly
          ? intl.formatMessage({
              id: 'XRayConfiguration.saveAndEvaluate.readOnlyModeTooltip',
              defaultMessage: 'You are in read-only mode.',
              description:
                'Tooltip for disabled save and evaluate button in read-only mode.',
            })
          : isEvaluating // order matters
            ? undefined
            : !configRequirementsMet
              ? intl.formatMessage({
                  id: 'XRayConfiguration.saveAndEvaluate.missingFieldsTooltip',
                  defaultMessage:
                    'Please fill in all fields to save and evaluate.',
                  description:
                    'Tooltip for disabled save and evaluate button when required fields are missing.',
                })
              : shouldRetry
                ? intl.formatMessage({
                    id: 'XRayConfiguration.saveAndEvaluate.retryEvaluationTooltip',
                    defaultMessage:
                      'Some model results failed to evaluate. Click to retry.',
                    description:
                      'Tooltip for retry evaluation button when some model results failed to evaluate.',
                  })
                : hasNoChanges
                  ? intl.formatMessage({
                      id: 'XRayConfiguration.saveAndEvaluate.noNewChangesTooltip',
                      defaultMessage: 'There are no new changes to evaluate.',
                      description:
                        'Tooltip for disabled save and evaluate button when there are no new changes.',
                    })
                  : undefined
      }
      onClick={onClick}
    />
  );
};
